import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import MonetizeSection from "./components/MonetizeSection";
import FeaturesSection from "./components/FeaturesSection";
import ShowcaseSection from "./components/ShowcaseSection";
import Pricing from "./components/Pricing";
import CtaBanner from "./components/CtaBanner";
import TestimonialCard from "./components/TestimonialCard";
import FaqComp from "./components/FaqComp";
import BlogComp from "./components/BlogComp";
import FooterComp from "./components/FooterComp";
import { GlobalContext } from "../context/GlobalContext";
import { TranslateContext } from "../context/TranslateContext";
import {
  parseHomepageShowcase,
  showcaseHasItems,
} from "../utils/homepageShowcase";

const FrontEnd = () => {
  const { hitAxios } = React.useContext(GlobalContext);
  const [web, setWeb] = React.useState({});
  const { lang } = React.useContext(TranslateContext);

  React.useEffect(() => {
    (async () => {
      const res = await hitAxios({
        path: "/api/web/get_web_public",
        post: false,
        admin: false,
        showLoading: false,
        showSnackbar: false,
      });
      if (res?.data?.success) setWeb(res.data.data);
    })();
  }, [hitAxios]);

  const siteName = web?.site_name || lang?.authDefaultSite || "Beyund AI";
  const hasShowcase = showcaseHasItems(
    parseHomepageShowcase(web?.homepage_showcase_json),
  );

  return (
    <div>
      <Header web={web} siteName={siteName} hasShowcase={hasShowcase} />

      <section id="overview">
        <Hero lang={lang} web={web} />
      </section>

      <MonetizeSection />

      <ShowcaseSection web={web} />

      <section id="features">
        <FeaturesSection />
      </section>

      <CtaBanner />

      <section id="pricing">
        <Pricing />
      </section>

      <TestimonialCard />

      <section id="faq">
        <FaqComp />
      </section>

      <BlogComp />

      <FooterComp web={web} siteName={siteName} />
    </div>
  );
};

export default FrontEnd;
